<template>
  <div>
    <loader v-if="loading"></loader>
    <b-row>
      <b-col md="12">
        <ul class="heading-ul">
          <li>
            <p class="mr-2" @click="goToViewPage()">
              <i class="fa fa-arrow-left" aria-hidden="true" style="font-size: 18px; color: #262626"></i>
            </p>
          </li>
          <li>
            <h3>Delivery Preference</h3>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-card class="p-4">
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col md="6">
              <div class="delivery-option-box p-4">
                <h4 class="font-weight-bolder mb-3">Delivery Options</h4>
                <b-form-group>
                  <b-form-checkbox type="checkbox" size="lg" v-model="pickFromShop" selected value="true">
                    <h4 class="ml-2 mt-1">Allow pick up from shop</h4>
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox type="checkbox" size="lg" v-model="globalDelivery">
                    <h4 class="ml-2 mt-1">Allow Global Delivery</h4>
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </b-col>
            <b-col md="6">
              <div class="delivery-option-box p-4">
                <h4 class="font-weight-bolder mb-3">Manage Delivery</h4>
                <b-form-group>
                  <b-form-radio-group id="radio-group-2" @change="selectedDeliveryOnChange()" v-model="selectedDelivery"
                    name="radio-sub-component">
                    <div class="form-group d-block">
                      <b-form-radio value="SELF" name="radio-size" size="lg">
                        <h4 class="ml-2 mt-1">Manage delivery by myself</h4>
                      </b-form-radio>
                    </div>
                    <div class="form-group d-flex">
                      <b-form-radio value="NIPIGE" name="radio-size" size="lg">
                        <h4 class="ml-2 mt-1">Delivery by Calonex</h4>
                      </b-form-radio>
                      <div v-if="selectedDelivery == 'NIPIGE'">
                        <eb-select class="m-0 dropmargin-0" :label="'key'" v-model="nipigeDeliverySelect"
                          placeholder="Select options" :options="nipigeDeliveryOptions"
                          :selected="nipigeDeliverySelect.key"></eb-select>
                      </div>
                    </div>
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <div class="text-center mt-4">
            <button type="button" class="btn btn-outline-primary mr-3 fix-btn-width" classic="mr-1 btn-outline-primary"
              text="Cancel">
              Cancel
            </button>
            <button type="button" class="btn btn-primary ml-3 fix-btn-width" classic="mr-1 btn-primary" text="Save"
              @click="saveDeliveryPref()">
              Save
            </button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import loader from "@/components/loader/nipigeloader.vue";
import ComponentHeader from "@/components/componentHeader";
import ebSelect from "@/components/FormElements/Select";
import currentUserData from "@/mixins/currentUser";
import { mapGetters } from "vuex";
import BilltoStepper from "@/components/SubOffice/BilltoStepper.vue";
export default {
  name: "DeliveryPreference",
  components: {
    ComponentHeader,
    ebSelect,
    loader,
    BilltoStepper,
  },
  mixins: [currentUserData],
  data() {
    return {
      loading: false,
      pickFromShop: false,
      nipigeDeliverySelect: "TENANT",
      nipigeDeliveryOptions: [],
      selectedDelivery: "SELF",
      currentUserData: "",
      globalDelivery: false,
    };
  },
  methods: {
    goToViewPage() {
      this.$router.push({
        name: "PartnerView",
        params: { id: this.$route.params.id, parentId: this.$route.params.parentId },
      });
    },
    selectedDeliveryOnChange() {
      this.nipigeDeliverySelect = "";
    },
    async extractParentHierarchy(data) {
      try {
        await this.$store.dispatch("partner/getMyParentAction", data);
        let newData = this.$store.getters["partner/getMyParentGatter"];
        if (newData != null) {
          this.nipigeDeliveryOptions.push({
            key: this.getCategory(newData.category),
            text: newData.category,
            id: newData._id,
            name: newData.authentication.userName,
            phone: newData.authentication.phone,
            email: newData.authentication.email,
          });
          this.extractParentHierarchy(newData._id);
        } else {
        }
      } catch { }
    },
    getCategory(data) {
      if (data) {
        if (data == "TENANT") {
          return "TENANT";
        } else if (data == "DISTRIBUTOR") {
          return "STATE_OPERATING_UNIT";
        } else if (data == "DEALER") {
          return "SECTOR_FRANCHISEE";
        } else if (data == "SUB_DEALER") {
          return "TSK";
        } else if (data == "TA") {
          return "TENANT";
        } else {
          return data;
        }
      } else {
        return "";
      }
    },
    async saveDeliveryPref() {
      const tenant = this.currentUserData.tenant;
      try {
        let payload = {
          allowPickupFromShop: this.pickFromShop,
          globalDelivery: this.globalDelivery,
          tenant: tenant,
        };
        if (this.selectedDelivery == "SELF") {
          payload.deliveryMethod = this.selectedDelivery;
          payload.provider = this.currentUserData._id;
        } else if (this.selectedDelivery == "NIPIGE") {
          payload.deliveryMethod = this.selectedDelivery;
          payload.provider = this.currentUserData._id;
          payload.category =
            this.nipigeDeliverySelect.text == "TA"
              ? "TENANT"
              : this.nipigeDeliverySelect.text;
        }
        await this.$store
          .dispatch("partner/updatePartnerdeliveryPreferences", payload)
          .then((res) => {
            this.$swal({
              title: "Success",
              text: "Delivery preferences set successfully!",
              type: "success",
            });
            if (this.$route.fullPath == "/myaccount/delivery-preference") {
              this.$router.push("/myaccount");
            } else {
              this.goToViewPage();
            }
          })
          .catch((err) => {
            this.$swal({
              title: "Error",
              text: "Can not set delivery preferences",
              type: "error",
            });
          });
      } catch {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      getPreferences: "partner/getPartnerPaymentPreferencesGetter",
      partnerAllData: "partner/GetPartnerData",
    }),
  },
  async mounted() {
    this.loading = true;

    if (this.$route.fullPath == "/myaccount/delivery-preference") {
      this.currentUserData = this.$currentUserData;
    } else {
      this.currentUserData = {
        ...this.partnerAllData,
        ...this.partnerAllData.authentication,
      };
    }
    let tenantDetails = await this.$store.dispatch(
      "tenant/getTenantDetailByID",
      this.currentUserData.tenant
    );
    try {
      this.nipigeDeliveryOptions.push({
        key: "TENANT",
        text: "TENANT",
        id: this.currentUserData.tenant,
        name: tenantDetails.response.authentication.userName,
        phone: tenantDetails.response.authentication.phone,
        email: tenantDetails.response.authentication.email,
      });
    } catch { }
    await this.extractParentHierarchy(this.currentUserData._id);
    await this.$store.dispatch(
      "partner/getPartnerPaymentPreferencesAction",
      this.currentUserData._id
    );
    try {
      if (this.getPreferences.preferences) {
        this.pickFromShop = this.getPreferences?.preferences?.delivery
          ?.allowPickupFromShop
          ? this.getPreferences?.preferences?.delivery?.allowPickupFromShop
          : false;
        this.globalDelivery = this.getPreferences?.preferences?.delivery?.globalDelivery
          ? this.getPreferences?.preferences?.delivery?.globalDelivery
          : false;
        this.selectedDelivery = this.getPreferences?.preferences?.delivery?.deliveryMethod
          ? this.getPreferences?.preferences?.delivery?.deliveryMethod
          : "SELF";
        this.nipigeDeliverySelect = {
          id: this.getPreferences?.preferences?.delivery?.deliveryOwner?.id
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.id
            : "",
          key: this.getPreferences?.preferences?.delivery?.deliveryOwner?.category
            ? this.getCategory(
              this.getPreferences?.preferences?.delivery?.deliveryOwner?.category
            )
            : "",
          text: this.getPreferences?.preferences?.delivery?.deliveryOwner?.category
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.category
            : "",

          email: this.getPreferences?.preferences?.delivery?.deliveryOwner?.email
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.email
            : "",
          phone: this.getPreferences?.preferences?.delivery?.deliveryOwner?.phone
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.phone
            : "",
          name: this.getPreferences?.preferences?.delivery?.deliveryOwner?.name
            ? this.getPreferences?.preferences?.delivery?.deliveryOwner?.name
            : "",
        };
      } else {
      }
    } catch { }
    this.loading = false;
  },
};
</script>
<style>
.heading-ul {
  padding: 0;
}

.heading-ul li {
  list-style: outside none;
  display: inline-block;
  margin-right: 10px;
}

.delivery-option-box {
  border: 1px solid #ddd;
  border-radius: 16px;
}

.dropmargin-0 .form-group {
  margin: 0;
}

.fix-btn-width {
  width: 150px;
  font-size: 16px;
}

.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #000000 solid 2px;
}

.delivery-radio-align {
  font-size: 20px;
  margin-left: 11px;
  margin-top: -2px;
  font-size: 20px;
}

[btn-color="primaryx"] {
  height: 39px;
  width: 120px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  text-align: center;
  border-radius: 0px;
}
</style>
